'use strict';
const ShoppingCart = require('od-modules/cart/cart');
const baggagesRowsCollection = require('../collections/baggages_rows').getInstance();
const {getStore} = require('od-modules/secure_store/store');

const merchandisingDiscountScope = {
    DE: true,
    ES: true,
    FR: true,
    IT: true,
    GB: true,
    GR: true,
    NL: true,
    PT: true,
    GOFR: true,
    OPDE: true,
    OPFR: true,
    OPIT: true,
    OPGB: true,
    OPNL: true,
    TRDE: true,
    TRGB: true,
};

const checkMerchandisingDiscountScope = () => {
    const flow = Odigeo.SessionScope.flow;
    const website = Odigeo.SessionScope.website;
    const isBaggagePrimePrice = Odigeo.AB.isBaggagePrimePriceMobile || Odigeo.AB.isBaggagePrimePriceDesktop;
    const isPromotionMerchandisingDiscountMobile = Odigeo.AB.isPromotionMerchandisingDiscountMobile;
    return !isBaggagePrimePrice
        && (flow === 'desktop' || isPromotionMerchandisingDiscountMobile)
        && merchandisingDiscountScope[website] === true;
};

const getPerksFromDapiKey = (idRow, idPassenger) => {
    return `${idRow}#${idPassenger}`;
};

const BaggageOptionDescriptor = Odigeo.Collection.extend({
    model: require('../models/baggage_row_option'),
    includedPieces: 0,
    selectedPieces: 0,
    allPiecesBySegment: {},
    selectedTotalPrice: 0,
    selectedTotalPricePlusDiscount: 0,
    discountFigure: null,
    selectedInCartTotalPrice: 0,
    perksFromDapi: {},
    allowAutoselection: null,
    allowSmartNag: null,
    allowRowsAutoselection: null,
    defaultOption: {
        price: 0,
    },
    BAGGAGE_TYPE: {
        notAllowed: 'NOT_ALLOWED',
        included: 'INCLUDED',
        includedSelectable: 'INCLUDED_SELECTABLE',
        selectable: 'SELECTABLE',
    },
    CONST: {
        MIN_PROPENSITY_MERCHANDISING_DISCOUNT: 0.6,
        MIN_PROPENSITY_MERCHANDISING_DISCOUNT_XMAS_AND_BLACK_FRIDAY: 0.6,
        MIN_PROPENSITY_THRESHOLD_NAG: 0.2,
        DISCOUNT_ROUND_UP: 5,
        NUM_SELECTED_BAGS: 'numSelected_bags',
    },
    initialize: function() {
        this.listenTo(this, 'change', this.notifySelectionToHandler);
    },
    fillData: function(descriptors, metas) {
        var shouldProceedWithFillData = !Odigeo._.isNaN(metas.idPassenger) && this.isOptionIdCorrect(metas.idRow);

        if (!shouldProceedWithFillData) {
            return;
        }

        Odigeo._.each(descriptors, function(descriptor) {
            this.add(Odigeo._.extend(descriptor, {
                idPassenger: metas.idPassenger,
                idRow: metas.idRow,
                isIncludedBaggage: metas.isIncludedBaggage,
                isSelectableBaggage: metas.isSelectableBaggage,
            }));
        }, this);
    },
    clearCollection: function() {
        this.selectedTotalPrice = 0;
        this.selectedTotalPricePlusDiscount = 0;
        this.selectedPieces = 0;
        this.includedPieces = 0;
        this.allPiecesBySegment = {};
        this.selectedInCartTotalPrice = 0;
        this.perksFromDapi = {};

        this.remove(this.models);
    },
    getDiscount: function() {
        return this.calculateDiscount(this.selectedTotalPrice);
    },
    calculateDiscount: function(total) {
        let discount = baggagesRowsCollection.getBaggageBundleDiscountPercentage();
        let finalPrice = 0;
        if (discount > 0) {
            finalPrice = total - ((discount / 100) * total);
        }
        return finalPrice;
    },
    getDiscountedPart: function() {
        const discount = baggagesRowsCollection.getBaggageBundleDiscountPercentage();
        const totalPrice = this.selectedTotalPrice;
        let finalPrice = 0;
        if (discount > 0) {
            finalPrice = ((discount / 100) * totalPrice) * (this.getFullSelection().length / this.selectedPieces);
        }
        return finalPrice;
    },
    getOption: function(searchPattern) {
        searchPattern = Odigeo._.isUndefined(searchPattern) ? {} : searchPattern;
        return this.findWhere(searchPattern);
    },
    getOptions: function(searchPattern) {
        searchPattern = Odigeo._.isUndefined(searchPattern) ? {} : searchPattern;
        return this.where(searchPattern);
    },
    getRowSelection: function(idPassenger, idRow) {
        return this.getOption({
            idPassenger: idPassenger,
            idRow: idRow,
            selected: true,
        });
    },
    getRowIncluded: function(idPassenger, idRow) {
        return this.getOption({
            idPassenger: idPassenger,
            idRow: idRow,
            isIncludedBaggage: true,
        });
    },
    getAllSelectedBaggageOptions() {
        return this.filter((element) => {
            return element.get('isSelectableBaggage')
                && element.get('selected')
                && element.get('pieces') > 0;
        });
    },
    getTotalSegmentsWithASelectableBaggage() {
        const segmentsWithSelectionAvailabilityStatus = this.reduce((acc, element) => {
            const key = element.get('idPassenger') + element.get('idRow');
            const isASelectableElement = element.get('isSelectableBaggage')
                && element.get('pieces') > 0;
            acc[key] = acc[key] || isASelectableElement;
            return acc;
        }, {});

        return Object.keys(segmentsWithSelectionAvailabilityStatus)
            .filter((key) => segmentsWithSelectionAvailabilityStatus[key]).length;
    },
    getPassengerSelection: function(idPassenger) {
        return this.getOptions({
            idPassenger: idPassenger,
            selected: true,
        });
    },
    getPassengerBaggageSelectedPieces(idPassenger) {
        return Odigeo._.reduce(this.getOptions( {
            idPassenger: idPassenger,
            selected: true,
        }), (total, option) => total + option.get('pieces'), 0);
    },
    getFullSelection: function() {
        return this.getOptions({
            selected: true,
        });
    },
    areAllPassengersWithBaggage: function() {
        return Odigeo._.every(this.getFullSelection(), function(segment) {
            return segment.get('pieces') > 0;
        });
    },
    getAllPieces: function() {
        return this.includedPieces + this.selectedPieces;
    },
    getAllPiecesBySegment: function() {
        return this.allPiecesBySegment;
    },
    selectDefaultOption(passengerId, rowId) {
        const {cid} = this.getDefaultOption(passengerId, rowId) || {};
        this.updateOption(cid);
    },
    getDefaultOption: function(passengerId, rowId) {
        return this.getOption(Odigeo._.extend({}, this.defaultOption, {
            idPassenger: passengerId,
            idRow: rowId,
        }));
    },
    executeBeforeUpdateHook: function(beforeUpdateHook, currentSelectedOption, newSelectedOption) {
        return Odigeo._.isFunction(beforeUpdateHook) ? beforeUpdateHook(currentSelectedOption, newSelectedOption) : true;
    },
    executeAfterUpdateHook: function(afterUpdateHook, currentSelectedOption, newSelectedOption) {
        if (Odigeo._.isFunction(afterUpdateHook)) {
            afterUpdateHook(currentSelectedOption, newSelectedOption);
        }
    },
    updateTotalInCartFromTotalPrice: function(areAllPassengersWithBaggage) {
        this.selectedInCartTotalPrice =
            (baggagesRowsCollection.getBaggageBundleDiscountPercentage() > 0
            && areAllPassengersWithBaggage && Odigeo.AB.isBaggageDiscountEnabled)
                ? this.calculateDiscount(this.selectedTotalPrice)
                : this.selectedTotalPrice;
    },
    /**
     * @param {Number} newOptionCid
     * @param {Object} beforeUpdateHook - {function(BaggageOptionDescriptor, BaggageOptionDescriptor)}
     *        pre-condition hook that must return boolean true to procede with update.
     * @param {Object} afterUpdateHook - {function(BaggageOptionDescriptor, BaggageOptionDescriptor)}
     *        only executes if update is done (beforeUpdateHook result is true)
     */
    updateOption: function(newOptionCid, beforeUpdateHook, afterUpdateHook) {
        var newSelectedOption = this.get(newOptionCid);
        var currentSelectedOption = this.getCurrentSelectedOption(newOptionCid);
        var isFirstSelection = Odigeo._.isUndefined(currentSelectedOption);
        var hasSelectionChanged = !isFirstSelection && currentSelectedOption.cid !== newSelectedOption.cid;

        if (isFirstSelection) {
            this.updateOptionSelectedState(newSelectedOption, true);
        } else if (hasSelectionChanged && this.executeBeforeUpdateHook(beforeUpdateHook, currentSelectedOption, newSelectedOption)) {
            this.updateOptionSelectedState(currentSelectedOption, false);
            this.updateOptionSelectedState(newSelectedOption, true);
            this.executeAfterUpdateHook(afterUpdateHook, currentSelectedOption, newSelectedOption);
        }
    },
    getCurrentSelectedOption: function(newOptionCid) {
        var newSelectedOption = this.get(newOptionCid);

        return this.getRowSelection(
            newSelectedOption.get('idPassenger'),
            newSelectedOption.get('idRow')
        );
    },
    updateOptionSelectedState: function(option, newState) {
        if (!Odigeo._.isUndefined(option)) {
            this.updateSelectedTotalsInfo(option, newState);
            option.set('selected', newState);
        }
    },
    updateSelectedTotalsInfo: function(selectedOption, selected) {
        const {isPrimeView = false} = this.getPrimeInfo();
        let pieces = selectedOption.get('piecesToShow');
        const fullPrice = selectedOption.get('price');
        const primePrice = selectedOption.get('primePrice');
        const usePrimePrice = isPrimeView && primePrice > 0 && primePrice < fullPrice;
        let price = usePrimePrice ? primePrice : fullPrice;

        if (selectedOption.get('isSelectableBaggage')) {
            if (!selected) {
                pieces = -pieces;
                price = -price;

                this.removePiecesBySegment(selectedOption);
            } else {
                this.addPiecesToSegment(selectedOption);
            }

            this.selectedPieces = this.selectedPieces + pieces;
            Odigeo.Session.set(this.CONST.NUM_SELECTED_BAGS, this.selectedPieces);
            this.updateTotalPrice(selected, price, isPrimeView);
        }
    },
    updateTotalPrice: function(selected, baggagePrice, isPrimeView) {
        const currentTotalPrice = this.selectedTotalPrice + baggagePrice;
        const isBaggagePropensityLowForMerchandisingDiscount = !isPrimeView
            && this.isBaggagePropensityLowForMerchandisingDiscount();
        const discountPercentage = isBaggagePropensityLowForMerchandisingDiscount ? this.getDiscountPercentage() : 0;

        this.selectedTotalPrice = currentTotalPrice;
        this.selectedTotalPricePlusDiscount = currentTotalPrice / (1 - (discountPercentage / 100));
    },
    getPassengerSelectableRows: function(idPassenger) {
        return baggagesRowsCollection.getPassengerSelectableRows(idPassenger);
    },
    getBaggagePropensity: function() {
        var firstBaggageSelectableRow = Odigeo._.first(this.getPassengerSelectableRows(0));
        return Odigeo._.isEmpty(firstBaggageSelectableRow) ? null : firstBaggageSelectableRow.get('baggagePropensity');
    },
    removePiecesBySegment: function(selectedOption) {
        var idRow = selectedOption.get('idRow');
        var cid = selectedOption.cid;

        if (Odigeo._.isObject(this.allPiecesBySegment[idRow]) &&
            Odigeo._.isObject(this.allPiecesBySegment[idRow][cid])) {
            delete this.allPiecesBySegment[idRow][cid];
        }
    },
    calculateIncludedPieces: function() {
        var includedArray = this.getOptions({isIncludedBaggage: true});
        var pieces;

        this.includedPieces = 0;

        Odigeo._.each(includedArray, function(includedOption) {
            pieces = includedOption.get('pieces');

            this.includedPieces += pieces;
            this.addPiecesToSegment(includedOption);
        }, this);
    },
    addPiecesToSegment: function(option) {
        var idRow = option.get('idRow');
        var cid = option.cid;

        if (Odigeo._.isUndefined(this.allPiecesBySegment[idRow])) {
            this.allPiecesBySegment[idRow] = {};
        }

        this.allPiecesBySegment[idRow][cid] = option;
    },
    isOptionIdCorrect: function(rowId) {
        return Odigeo._.isString(rowId) && rowId.length > 0;
    },
    hasSecondLegSameCombinations: function() {
        var firstRowOptions = this.getOptions({idRow: 'FIRST'});

        return Odigeo._.every(firstRowOptions, function(rowOption) {
            var searchPattern = Odigeo._.extend({idRow: 'SECOND'}, Odigeo._.pick(rowOption.getAll(), 'pieces', 'kilos'));

            return !Odigeo._.isUndefined(this.getOption(searchPattern));
        }, this);
    },
    hasSecondLegSameCombinationsWithoutWeight: function() {
        var firstRowOptions;
        var secondRowOptions;

        if (this.hasSecondLegSameCombinations()) {
            return true;
        }

        firstRowOptions = this.getOptions({idRow: 'FIRST'});
        secondRowOptions = this.getOptions({idRow: 'SECOND'});

        return this.checkIfLegContainNonRepeatedCaseNumbers(firstRowOptions) &&
            this.checkIfLegContainNonRepeatedCaseNumbers(secondRowOptions) &&
            this.isFirstSegmentOptionsASubsetOfSecondSegment(firstRowOptions);
    },
    isFirstSegmentOptionsASubsetOfSecondSegment: function(firstRowOptions) {
        return Odigeo._.every(firstRowOptions, function(rowOption) {
            var searchPattern = Odigeo._.extend({idRow: 'SECOND'}, Odigeo._.pick(rowOption.getAll(), 'pieces'));

            return !Odigeo._.isUndefined(this.getOption(searchPattern));
        }, this);
    },
    checkIfLegContainNonRepeatedCaseNumbers: function(options) {
        // Checks if a segment's options have repeated elements for the same number of cases. i.e.:
        // 1 bag 20kg
        // 1 bag 23kg (two options for one bag)
        return options.length === Odigeo._.uniq(options, function(option) {
            return option.get('pieces') + '--' + option.get('idPassenger');
        }).length;
    },
    doOptionsAllowAutoselection: function() {
        if (Odigeo._.isNull(this.allowAutoselection)) {
            this.allowAutoselection = this.hasSecondLegSameCombinationsWithoutWeight();
        }
        return this.allowAutoselection;
    },
    doOptionsAllowSmartNag: function() {
        if (Odigeo._.isNull(this.allowSmartNag)) {
            this.allowSmartNag = Odigeo.AB.isBaggageGroupedBySegment
                ? this.doRowsAllowAutoselection()
                : this.hasSecondLegSameCombinationsWithoutWeight();
        }

        return this.allowSmartNag;
    },
    doRowsAllowAutoselection: function() {
        return this.allowRowsAutoselection;
    },
    setAllowRowsAutoselection: function(value) {
        this.allowRowsAutoselection = value;
    },
    getCheapestSelectableBag(priceProp = 'price') {
        let options = this.getOptions({
            idPassenger: 0,
            isSelectableBaggage: true,
        }).filter((item) => item.get('piecesToShow') > 0);

        return options.reduce((acc, option) => {
            const price = option.get(priceProp);
            return !acc || (price && price < acc.get(priceProp)) ? option : acc;
        }, null);
    },
    getDiscountPercentage: function() {
        const discount = this.discountFigure || 0;
        const cheapestOption = this.getCheapestSelectableBag('price');
        const price = cheapestOption?.get('price');

        let discountPercentage = price
            ? Odigeo._.ceil((discount / (price + discount)) * 100)
            : 0;

        if (discountPercentage) {
            discountPercentage = Odigeo._.ceil(discountPercentage / this.CONST.DISCOUNT_ROUND_UP) * this.CONST.DISCOUNT_ROUND_UP;
        }

        return discountPercentage;
    },
    getPrimeSavedAmount() {
        const savedAmount = (this.getAllSelectedBaggageOptions() || [])
            .reduce((acc, selectedBag) => {
                const primePrice = selectedBag.get('primePrice');
                return primePrice ? acc + selectedBag.get('price') - primePrice : acc;
            }, 0);
        return savedAmount > 0 ? savedAmount : 0;
    },
    setDiscountFigure(discount) {
        this.discountFigure = discount;
    },
    getDiscountFigure() {
        return this.discountFigure;
    },
    isBaggagePropensityLowForNag() {
        return Odigeo.AB.isBagPropensityNag
            && this.isBaggagePropensityLow(this.CONST.MIN_PROPENSITY_THRESHOLD_NAG);
    },
    isBaggagePropensityLowForMerchandisingDiscount() {
        const minPropensity = Odigeo.AB.promotionMerchandisingBlackFriday || Odigeo.AB.promotionMerchandisingXmas
            ? this.CONST.MIN_PROPENSITY_MERCHANDISING_DISCOUNT_XMAS_AND_BLACK_FRIDAY
            : this.CONST.MIN_PROPENSITY_MERCHANDISING_DISCOUNT;
        return checkMerchandisingDiscountScope() && this.isBaggagePropensityLow(minPropensity);
    },

    isBaggagePropensityLow: function(propensityThreshold) {
        const baggagePropensity = this.getBaggagePropensity();
        return Odigeo._.isNumber(baggagePropensity) && baggagePropensity <= propensityThreshold;
    },
    getPrimeInfo: () => this.primeInfo || {},
    setPrimeInfo: (primeInfo) => {
        this.primeInfo = primeInfo;
    },
    getMerchandisingDiscountInfo() {
        return getStore()?.ancillariesInformation?.merchandisingDiscount || {};
    },
    getPerksFromDapi() {
        return this.perksFromDapi;
    },
    addPerksFromDapi(idRow, idPassenger, selectedPrice, selectedPrimePrice) {
        const parsedPrice = selectedPrice || 0;
        const parsedPrimePrice = selectedPrimePrice || selectedPrice;
        const perksFromDapiKey = getPerksFromDapiKey(idRow, idPassenger);
        this.perksFromDapi[perksFromDapiKey] = parsedPrice - parsedPrimePrice;
    },
    updateShoppingCart(option = {}) {
        const {attributes = {}} = option;
        const {idPassenger, idRow, pieces, price, primePrice, piecesToShow} = attributes;
        const {isPrimeView = false} = this.getPrimeInfo() || {};
        const usePrimePrice = ((primePrice > 0 && primePrice < price) || (pieces === 0));
        let total = price;
        let primePerksFromClient = 0;
        let primePerksFromDapi = 0;

        if (usePrimePrice) {
            const perksFromDapiKey = getPerksFromDapiKey(idRow, idPassenger);
            total = primePrice;
            primePerksFromClient = price - primePrice;
            primePerksFromDapi = this.perksFromDapi[perksFromDapiKey] || 0;
        }

        ShoppingCart.builders.bag.data({
            idPassenger,
            idRow,
            quantity: piecesToShow,
            usePrimePrice,
            isPrimeView,
            price: {
                total,
            },
            perks: {
                fromClient: primePerksFromClient,
                fromDapi: primePerksFromDapi,
            },
            selection: attributes,
        }).fromWidget().add();
    },
});

var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggageOptionDescriptor();
    }
    return instance;
};
